import { useEffect, useState } from "react";
import { Popover } from "react-tiny-popover";

const Pagination = ({ onChange, total = 0, currentPage }) => {
   const [isOpen, setIsOpen] = useState(false);
   const [pageSize, setPageSize] = useState(10);
   const listPageSize = [10, 20, 50];
   const [page, setPage] = useState(1);
   const totalPage = Math.ceil(total / pageSize);

   const handleChangePageSize = (size) => {
      setPageSize(size);
      setIsOpen(false);
      setPage(1);
      onChange(1, size);
   }

   useEffect(() => {
      if (currentPage) {
         setPage(currentPage);
      }
   }, [currentPage]);

   const getPaginate = () => {
      const pagination = [];
      const delta = 1;
      pagination.push(1);
      // Thêm dấu chấm nếu cần
      if (page - delta > 2) {
         pagination.push("before");
      }
      // Thêm các trang liền kề trước và sau trang hiện tại
      for (let i = Math.max(2, page - delta); i <= Math.min(totalPage - 1, page + delta); i++) {
         pagination.push(i);
      }
      // Thêm dấu chấm nếu cần
      if (page + delta < totalPage - 1) {
         pagination.push("after");
      }
      // Thêm trang cuối cùng
      if (totalPage > 1) {
         pagination.push(totalPage);
      }
      return pagination;
   }

   const handleSetPage = (p) => {
      if (p !== page) {
         setPage(p);
         onChange(p, pageSize)
      }
   }

   const renderPaginate = (paginate, index) => {
      if (typeof paginate === 'number') {
         return (
            <li className={`app-pagination--item ${paginate === page && "app-pagination--item-active"}`} key={index} onClick={() => handleSetPage(paginate)}>
               <a>{paginate}</a>
            </li>
         )
      }

      if (paginate === 'after') {
         return (
            <li className="app-pagination--item" key={index} onClick={() => {
               const p = (page + 3 <= totalPage) ? (page + 3) : totalPage;
               handleSetPage(p);
            }}>
               <svg className="app-svg-inline-block" width="16px" height="16px" viewBox="0 0 16 4">
                  <path d="M2 4C3.10449 4 4 3.10449 4 2C4 0.895508 3.10449 0 2 0C0.895508 0 0 0.895508 0 2C0 3.10449 0.895508 4 2 4ZM8 4C9.10449 4 10 3.10449 10 2C10 0.895508 9.10449 0 8 0C6.89551 0 6 0.895508 6 2C6 3.10449 6.89551 4 8 4ZM16 2C16 3.10449 15.1045 4 14 4C12.8955 4 12 3.10449 12 2C12 0.895508 12.8955 0 14 0C15.1045 0 16 0.895508 16 2Z">
                  </path>
               </svg>
            </li>
         )
      }

      if (paginate === 'before') {
         return (
            <li className="app-pagination--item" key={index} onClick={() => {
               const p = (page - 3 >= 1) ? (page - 3) : 1;
               handleSetPage(p);
            }}>
               <svg className="app-svg-inline-block" width="16px" height="16px" viewBox="0 0 16 4">
                  <path d="M2 4C3.10449 4 4 3.10449 4 2C4 0.895508 3.10449 0 2 0C0.895508 0 0 0.895508 0 2C0 3.10449 0.895508 4 2 4ZM8 4C9.10449 4 10 3.10449 10 2C10 0.895508 9.10449 0 8 0C6.89551 0 6 0.895508 6 2C6 3.10449 6.89551 4 8 4ZM16 2C16 3.10449 15.1045 4 14 4C12.8955 4 12 3.10449 12 2C12 0.895508 12.8955 0 14 0C15.1045 0 16 0.895508 16 2Z">
                  </path>
               </svg>
            </li>
         )
      }
   }

   return (
      <div className="app-pagination ">
         <div className="app-pagination--options">
            <div className="app-pagination-dropdown">
               <div className="app-pagination-dropdown--text">
                  Hiển thị
               </div>
               <Popover
                  isOpen={isOpen}
                  align={'center'}
                  positions={['left', 'top']}
                  onClickOutside={() => setIsOpen(false)}
                  clickOutsideCapture={true}
                  content={
                     <div className="app-popover app-pagination-dropdown--popup app-popover-hidden-arrow app-popover-placement-top" style={{ top: 'unset', bottom: 20 }}>
                        <div className="app-popover-content">
                           <div className="app-popover-arrow"></div>
                           <div className="app-popover-inner" role="tooltip">
                              <div>
                                 <div className="app-popover-inner-content">
                                    <div>
                                       <div className="app-dropdown-menu">
                                          {listPageSize.map((item, index) => (
                                             <div
                                                className={`app-dropdown-menu-item ${item === pageSize && "active"}`}
                                                key={index}
                                                onClick={() => handleChangePageSize(item)}
                                             >
                                                {item}
                                             </div>
                                          ))}
                                       </div>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  }
               >
                  <div className="app-pagination-dropdown--btn" onClick={() => setIsOpen(!isOpen)}>
                     <div className="app-pagination-dropdown--number">
                        {pageSize}
                     </div>
                     <div className="app-pagination-dropdown--icon">
                        <svg className="app-svg-inline-block app-svg-next-icon-rotate-90" width="16px" height="16px" viewBox="0 0 16 16">
                           <path d="M6.47 4L5.53 4.94L8.58333 8L5.53 11.06L6.47 12L10.47 8L6.47 4Z">
                           </path>
                        </svg>
                     </div>
                  </div>
               </Popover>
            </div>
         </div>
         <ul className="app-pagination--listpage">
            <li className="app-pagination-total-text">
               Đang hiển thị {page}-{totalPage} / {total}
            </li>
            {totalPage > 1 &&
               <li className={`app-pagination--item ${page === 1 && "app-pagination--disabled"}`} onClick={() => {
                  const p = page - 1 > 1 ? page - 1 : 1;
                  handleSetPage(p);
               }}>
                  <svg className="app-svg-inline-block app-svg-next-icon-rotate-180" width="16px" height="16px" viewBox="0 0 16 16">
                     <path d="M6.47 4L5.53 4.94L8.58333 8L5.53 11.06L6.47 12L10.47 8L6.47 4Z">
                     </path>
                  </svg>
               </li>
            }
            {getPaginate().map(renderPaginate)}
            {totalPage > 1 &&
               <li className={`app-pagination--item ${page === totalPage && "app-pagination--disabled"}`} onClick={() => {
                  const p = page + 1 < totalPage ? page + 1 : totalPage;
                  handleSetPage(p);
               }}>
                  <svg className="app-svg-inline-block" width="16px" height="16px" viewBox="0 0 16 16">
                     <path d="M6.47 4L5.53 4.94L8.58333 8L5.53 11.06L6.47 12L10.47 8L6.47 4Z">
                     </path>
                  </svg>
               </li>
            }
         </ul>
      </div>
   )
}

export default Pagination;